/* eslint-disable */

import axios from 'axios'
import crypto from 'crypto'
import jwtDecode from 'jwt-decode'
// import EventEmitter from 'eventemitter3'
import router from './../router'

const ADMIN_API_KEY = process.env.ADMIN_API_KEY
const BUSINESS_API_KEY = process.env.BUSINESS_API_KEY
const COMMON_API_KEY = process.env.COMMON_API_KEY
const COMMON_API_URL = process.env.COMMON_API_URL
const INDIVIDUAL_API_KEY = process.env.INDIVIDUAL_API_KEY
const SERVICE_API_KEY = process.env.SERVICE_API_KEY

export class AuthService {
  // authenticated = this.isAuthenticated()
  // authNotifier = new EventEmitter()

  constructor () {
    this.login = this.login.bind(this)
    this.setSession = this.setSession.bind(this)
    this.setIsEventOrganizer = this.setIsEventOrganizer.bind(this)
    this.logout = this.logout.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
  }

  login (params) {
    const url = `${COMMON_API_URL}/login`
    const headers = { headers: { 'x-api-key': COMMON_API_KEY } }
    return axios.post(url, params, headers).then(response => response.data).catch(err => err.response.data)
  }

  changePassword (params) {
    const url = `${COMMON_API_URL}/change_password`
    const headers = this.getCommonApiKeyHeader()
    return axios.post(url, params, headers).then(r => r.data).catch(e => e.response.data)
  }

  setSession (authResult) {
    var decoded = jwtDecode(authResult.id_token)
    let expiresAt = JSON.stringify(decoded.exp)

    localStorage.setItem('access_token', authResult.access_token)
    localStorage.setItem('id_token', authResult.id_token)
    localStorage.setItem('expires_at', expiresAt)
    localStorage.setItem('uid', authResult.user_id)
    localStorage.setItem('account_type', authResult.account_type)
    localStorage.setItem('username', authResult.username)

    if(authResult.account_type === 'business') {
      const isEventOrganizer = authResult.profile_details.company_details.is_event_organizer
      localStorage.setItem('company_id', authResult.profile_details.company_id)
      localStorage.setItem('is_event_organizer', JSON.stringify(isEventOrganizer))
    } else {
      var uname = authResult.profile_details.first_name.concat(' ' + authResult.profile_details.last_name)
      localStorage.setItem('uname', this.toTitleCase(uname.toLowerCase()))
    }
  }

  logout () {
    localStorage.clear()
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    // console.log('expiresAt: ', expiresAt)
    // console.log('datenow: ', Date.now().valueOf() / 1000)
    let isAuthenticated = false
    if(expiresAt) {
      isAuthenticated = expiresAt > Date.now().valueOf() / 1000
      // console.log('isAuthenticated: ', isAuthenticated)
      if(!isAuthenticated) {
        this.logout()
      }
    }
    return isAuthenticated
  }

  setProfilePicture(picture) {
    localStorage.setItem('profile_picture', picture)
  }

  setUsername(username) {
    localStorage.setItem('username', username)
  }

  setAccountType(type) {
    localStorage.setItem('account_type', type)
  }

  setIsEventOrganizer(value) {
    localStorage.setItem('is_event_organizer', JSON.stringify(value))
  }

  getIsEventOrganizer() {
    return JSON.parse(localStorage.getItem('is_event_organizer'))
  }

  getProfilePicture() {
    return localStorage.getItem('profile_picture')
  }

  getAuthToken() {
    return localStorage.getItem('id_token')
  }

  getUserId() {
    return localStorage.getItem('uid')
  }

  getAccountType() {
    return localStorage.getItem('account_type')
  }

  getUsername() {
    return localStorage.getItem('username')
  }

  getUname() {
    return localStorage.getItem('uname')
  }

  getCompanyName() {
    return localStorage.getItem('company_name')
  }

  getCompanyId() {
    return localStorage.getItem('company_id')
  }

  getAdminApiKeyHeader() {
    return { headers: { 'x-api-key': ADMIN_API_KEY } }
  }

  getCommonApiKeyHeader() {
    return { headers: { 'x-api-key': COMMON_API_KEY } }
  }

  getBusinessApiKeyHeader() {
    return { headers: { 'x-api-key': BUSINESS_API_KEY } }
  }

  getIndividualApiKeyHeader() {
    return { headers: { 'x-api-key': INDIVIDUAL_API_KEY } }
  }

  getServiceApiKeyHeader() {
    return { headers: { 'x-api-key': SERVICE_API_KEY } }
  }

  getBusinessAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': BUSINESS_API_KEY
      }
    }
  }

  getCommonAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': COMMON_API_KEY
      }
    }
  }

  getIndividualAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': INDIVIDUAL_API_KEY
      }
    }
  }

  getAdminContentAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': ADMIN_API_KEY,
        'Content-Type': 'application/json'
      }
    }
  }

  getBusinessContentAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': BUSINESS_API_KEY,
        'Content-Type': 'application/json'
      }
    }
  }

  getCommonContentAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': COMMON_API_KEY,
        'Content-Type': 'application/json'
      }
    }
  }

  getIndividualContentAuthHeader() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.getAuthToken(),
        'x-api-key': INDIVIDUAL_API_KEY,
        'Content-Type': 'application/json'
      }
    }
  }

  // HELPERS
  toTitleCase(str) {
    return str.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() })
  }
}



// WEBPACK FOOTER //
// ./src/api/AuthService.js